import { render, staticRenderFns } from "./fundsFromIndex.vue?vue&type=template&id=5b52be5a&"
import script from "./fundsFromIndex.vue?vue&type=script&lang=js&"
export * from "./fundsFromIndex.vue?vue&type=script&lang=js&"
import style0 from "./fundsFromIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports